import { strFromU8, unzipSync } from 'fflate';

import type { PersonalSkin } from './types';

const PACKAGE_FILE = 'skin.json';

export function serializePersonalSkin(skin: PersonalSkin): Uint8Array {
  const payload = JSON.stringify({ format: 'zxtalk.personal-skin', version: 1, skin });
  return new TextEncoder().encode(payload);
}

export function exportPersonalSkin(skin: PersonalSkin): Blob {
  return new Blob([serializePersonalSkin(skin)], {
    type: 'application/x-zxtalk-skin',
  });
}

export function exportFileName(skin: PersonalSkin): string {
  const safe = skin.name.replace(/[\\/:*?"<>|]+/g, '-').trim() || '栀歆皮肤';
  return `${safe}.zskin`;
}

export function parsePersonalSkinPackage(bytes: Uint8Array): PersonalSkin {
  let raw: unknown;
  try {
    raw = JSON.parse(new TextDecoder().decode(bytes)) as unknown;
  } catch {
    // Backward-compatible reader for ZIP-formatted .zskin files.
    let files: Record<string, Uint8Array>;
    try {
      files = unzipSync(bytes);
    } catch {
      throw new Error('不是有效的 .zskin 皮肤包');
    }
    const file = files[PACKAGE_FILE];
    if (!file) throw new Error('皮肤包缺少 skin.json');
    try {
      raw = JSON.parse(strFromU8(file)) as unknown;
    } catch {
      throw new Error('皮肤包 JSON 损坏');
    }
  }
  if (raw === null || typeof raw !== 'object') throw new Error('皮肤包结构无效');
  const envelope = raw as { format?: unknown; version?: unknown; skin?: unknown };
  if (envelope.format !== 'zxtalk.personal-skin' || envelope.version !== 1) {
    throw new Error('不支持的皮肤包格式');
  }
  const skin = envelope.skin as Partial<PersonalSkin> | undefined;
  if (
    !skin ||
    typeof skin.id !== 'string' ||
    typeof skin.name !== 'string' ||
    !skin.base ||
    typeof skin.base !== 'object' ||
    !skin.overrides ||
    typeof skin.overrides !== 'object' ||
    !skin.assets ||
    typeof skin.assets !== 'object'
  ) {
    throw new Error('皮肤包内容不完整');
  }
  return {
    id: skin.id,
    name: skin.name,
    createdAt: typeof skin.createdAt === 'number' ? skin.createdAt : Date.now(),
    updatedAt: Date.now(),
    base: skin.base,
    assets: skin.assets,
    overrides: skin.overrides,
  };
}

